import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import { BarChart3, LayoutGrid, Zap, Target, Settings, DollarSign } from 'lucide-react'
import Dashboard from './components/Dashboard'
import ProjectGallery from './components/ProjectGallery'
import CampaignManager from './components/CampaignManager'
import FunnelGenerator from './components/FunnelGenerator'
import SettingsPage from './components/SettingsPage'
import PricingPage from './components/PricingPage'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-900">
        {/* Navigation */}
        <nav className="bg-slate-800 border-b border-slate-700">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center">
                <Zap className="h-8 w-8 text-sky-500" />
                <span className="ml-2 text-xl font-bold text-white">
                  Marketing Bot
                </span>
              </div>
              
              <div className="flex space-x-4">
                <Link
                  to="/dashboard"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-slate-700 hover:text-white"
                >
                  <BarChart3 className="h-5 w-5 mr-2" />
                  대시보드
                </Link>
                <Link
                  to="/projects"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-slate-700 hover:text-white"
                >
                  <LayoutGrid className="h-5 w-5 mr-2" />
                  프로젝트
                </Link>
                <Link
                  to="/campaigns"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-slate-700 hover:text-white"
                >
                  <Target className="h-5 w-5 mr-2" />
                  캠페인
                </Link>
                <Link
                  to="/funnel"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-slate-700 hover:text-white"
                >
                  <Zap className="h-5 w-5 mr-2" />
                  퍼널 생성
                </Link>
                <Link
                  to="/settings"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-slate-700 hover:text-white"
                >
                  <Settings className="h-5 w-5 mr-2" />
                  설정
                </Link>
                <Link
                  to="/pricing"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-slate-700 hover:text-white"
                >
                  <DollarSign className="h-5 w-5 mr-2" />
                  과금 현황
                </Link>
              </div>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projects" element={<ProjectGallery />} />
            <Route path="/2006" element={<ProjectGallery />} />
            <Route path="/campaigns" element={<CampaignManager />} />
            <Route path="/funnel" element={<FunnelGenerator />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  )
}

export default App
